import { fromBase64 } from "../../../utils/base64";
import {
  TDocument,
  TLinkedVerificationRequest,
  TLinkedVerificationRequestResponse,
  TVerificationRequestEntitySummary,
  TVerificationRequest,
  TVerificationRequestUserSummary,
} from "../models";
import countries from "../../../data/countries.json";

const parseAdditionalItem = <T extends Record<string, unknown>>(
  payload?: string
): T | undefined => {
  if (!payload) {
    return undefined;
  }

  try {
    const parsed = JSON.parse(fromBase64(payload));

    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return parsed as T;
    }
  } catch (error) {
    return undefined;
  }

  return undefined;
};

export const mapVerificationRequestIn = (
  data: TVerificationRequest
): TVerificationRequest => {
  if (data.additionalItems) {
    data.additionalItems.userInformationParsed =
      parseAdditionalItem<TVerificationRequestUserSummary>(
        data.additionalItems.user_information
      );
    data.additionalItems.entityInformationParsed =
      parseAdditionalItem<TVerificationRequestEntitySummary>(
        data.additionalItems.entity_information
      );
  }

  return data;
};

export const mapLinkedVerificationRequestIn = (
  data: TLinkedVerificationRequestResponse
): TLinkedVerificationRequest => ({
  ...data,
});

const countryFields = ["country_of_birth", "nationality", "country", "second_nationality"];
export const mapDocument = (data: any): TDocument => {
  Object.keys(data).forEach((key) => {
    if (countryFields.includes(key)) {
      if (data[key]) {
        const country = countries.find((country) => country.code === data[key]);
        data[key] = country?.name;
      }
    }
  });

  return data;
};
